var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.25,
    d: "M6.879 0a.586.586 0 00-.267.144l-6.23 5.16A.659.659 0 000 5.921v18.421c0 .362.274.658.61.658h18.312a.594.594 0 00.114-.02l.057-.021a.63.63 0 00.362-.309l4.802-6.476a.695.695 0 00.133-.41V.78a.69.69 0 00-.19-.596.317.317 0 00-.02-.041h-.018a.3.3 0 00-.038-.041h-.02A.767.767 0 0024.01.04a.56.56 0 00-.172-.04H6.879zm.305 1.316h6.46L9.526 5.263H2.401l4.783-3.947zm8.289 0h6.821l-3.658 3.947h-7.28l4.117-3.947zm7.698.946v15.275l-3.659 4.934V6.21l3.659-3.947zM1.22 6.579h8.307a.581.581 0 00.363 0h8.403v17.105H1.22V6.58zM6.593 9.21c-.336.033-.584.357-.553.72.031.361.332.629.667.595h6.098a.604.604 0 00.536-.326.71.71 0 000-.663.606.606 0 00-.536-.326H6.593z"
  })));
}

export default SvgCommonIconBox;